module.exports = "https://cdn.littlereply.com/tt/resource/tik_tok_splash.87abf3c36a6903106e99c425feec2a0c.png";